import Base from 'app/models/selection';

export default Base.extend({
  getReadable() {
    return this.get('currentChoice').readable;
  },
});



// WEBPACK FOOTER //
// ./app/models/dropdown_selection.js